const discountSourceEnum = Object.freeze({
  LOYALTY: 'LOYALTY',
  PROMO_CODE: 'PROMO_CODE',
  AUTO_DISCOUNT: 'AUTO_DISCOUNT',
});

export default discountSourceEnum;
